(function () {
  'use strict';

  var config = window.FreeCapGiftConfig || {};
  var gifts = (config.gifts || []).filter(function (gift) { return gift.variantId; });
  var eligibleCartProductIds = (config.eligibleCartProductIds || []).map(Number);
  var nativeFetch = window.fetch.bind(window);
  var cartMutationPattern = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;
  var syncing = false;
  var syncQueued = false;
  var replayingAction = false;
  var pendingAction = null;
  var selectedGift = null;
  var picker;
  var confirmButton;
  var pickerError;
  var lastFocusedElement;

  function request(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = Object.assign({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, options.headers || {});
    return nativeFetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return response.json();
    });
  }

  function giftByVariantId(variantId) {
    return gifts.find(function (gift) { return Number(gift.variantId) === Number(variantId); });
  }

  function giftForItem(item) {
    return gifts.find(function (gift) {
      return Number(item.product_id) === Number(gift.productId) || item.handle === gift.handle;
    });
  }

  function isGift(item) {
    return Boolean(giftForItem(item));
  }

  function storedEligibleProductIds() {
    try {
      return JSON.parse(sessionStorage.getItem('freeCapEligibleProductIds') || '[]').map(Number);
    } catch (error) {
      return [];
    }
  }

  function rememberEligibleProductId(productId) {
    productId = Number(productId);
    if (!productId) return;
    var productIds = storedEligibleProductIds();
    if (productIds.indexOf(productId) === -1) productIds.push(productId);
    sessionStorage.setItem('freeCapEligibleProductIds', JSON.stringify(productIds));
  }

  function isEligibleProduct(item) {
    if (isGift(item)) return false;
    var productId = Number(item.product_id);
    var markedEligible = item.properties && String(item.properties._free_cap_eligible) === 'true';
    return markedEligible || eligibleCartProductIds.indexOf(productId) !== -1 || storedEligibleProductIds().indexOf(productId) !== -1;
  }

  function productContext(element) {
    if (!element) return null;
    return element.closest('.js-product-card, #jsQuickview, [data-section-type="product"], .product-template');
  }

  function elementIsEligible(element) {
    if (!element) return false;
    if (config.currentProductIsEligible && document.body.classList.contains('template-product')) return true;
    var context = productContext(element);
    return Boolean(context && context.getAttribute('data-free-cap-eligible') === 'true');
  }

  function rememberElementEligibility(element) {
    var context = productContext(element);
    var productId = context && context.getAttribute('data-product-id');
    if (!productId && config.currentProductIsEligible) productId = config.currentProductId;
    rememberEligibleProductId(productId);
  }

  function markFormEligible(form) {
    if (!form || form.querySelector('[name="properties[_free_cap_eligible]"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_free_cap_eligible]';
    input.value = 'true';
    form.appendChild(input);
  }

  function getStoredGift() {
    return giftByVariantId(sessionStorage.getItem('freeCapGiftVariantId'));
  }

  function storeGift(gift) {
    selectedGift = gift;
    sessionStorage.setItem('freeCapGiftVariantId', String(gift.variantId));
    sessionStorage.setItem('freeCapGiftTitle', gift.title);
  }

  function cartPageIsOpen() {
    return document.body && document.body.classList.contains('template-cart');
  }

  function refreshThemeCart() {
    window.setTimeout(function () {
      if (window.theme && theme.miniCart) {
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();
      }
      decorateGiftItems();
    }, 80);
  }

  function addGift(gift) {
    return request(config.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [{
          id: Number(gift.variantId),
          quantity: 1,
          properties: {
            _free_gift: 'Free Cap with Eligible Product',
            _gift_choice: gift.title
          }
        }]
      })
    });
  }

  function changeGift(lineKey, quantity) {
    return request(config.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  function runSequentially(tasks) {
    return tasks.reduce(function (promise, task) {
      return promise.then(task);
    }, Promise.resolve());
  }

  function showSurprise(gift) {
    if (document.querySelector('.free-cap-surprise')) return;
    var title = gift && gift.title ? gift.title : 'Free Cap';
    var image = gift && gift.image ? '<img src="' + gift.image + '" alt="">' : '<span aria-hidden="true">&#127873;</span>';

    var message = document.createElement('div');
    message.className = 'free-cap-surprise';
    message.setAttribute('role', 'status');
    message.innerHTML = '<span class="free-cap-surprise__icon">' + image + '</span>' +
      '<strong>' + title + ' added!</strong>' +
      '<span>Your complimentary gift is in the cart.</span>';
    document.body.appendChild(message);

    var colors = ['#ff9004', '#111111', '#ffd166', '#35a36f', '#ffffff'];
    for (var i = 0; i < 28; i += 1) {
      var piece = document.createElement('i');
      piece.className = 'free-cap-confetti';
      piece.style.left = Math.round(Math.random() * 100) + 'vw';
      piece.style.background = colors[i % colors.length];
      piece.style.setProperty('--gift-drift', Math.round(Math.random() * 180 - 90) + 'px');
      piece.style.animationDelay = Math.round(Math.random() * 450) + 'ms';
      document.body.appendChild(piece);
      window.setTimeout((function (node) { return function () { node.remove(); }; })(piece), 2600);
    }
    window.setTimeout(function () { message.remove(); }, 2900);
  }

  function decorateGiftItems(animate) {
    gifts.forEach(function (gift) {
      var links = document.querySelectorAll('a[href*="/products/' + gift.handle + '"]');
      links.forEach(function (link) {
        var item = link.closest('.mini-cart-item, .cart__row');
        if (!item) return;
        item.classList.add('free-cap-gift-item');
        if (animate) item.classList.add('free-cap-gift-pop');

        var meta = item.querySelector('.mini-cart-meta, td:nth-child(2), .d-lg-none');
        if (meta && !meta.querySelector('.free-cap-gift-label')) {
          var label = document.createElement('span');
          label.className = 'free-cap-gift-label';
          label.innerHTML = '<span aria-hidden="true">&#10003;</span> Your selected complimentary gift';
          meta.appendChild(label);
        }

        item.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
          input.disabled = true;
          input.removeAttribute('name');
        });
      });
    });
  }

  function finishCartChange(giftWasAdded, gift) {
    if (giftWasAdded) {
      sessionStorage.setItem('freeCapGiftSurprise', '1');
      sessionStorage.setItem('freeCapGiftSurpriseVariant', String(gift.variantId));
    }

    if (cartPageIsOpen()) {
      window.location.reload();
      return;
    }

    refreshThemeCart();
    if (giftWasAdded) {
      window.setTimeout(function () {
        var drawer = document.querySelector('.js-mini-cart.cardraw');
        if (drawer) drawer.classList.add('active');
        decorateGiftItems(true);
        showSurprise(gift);
        sessionStorage.removeItem('freeCapGiftSurprise');
        sessionStorage.removeItem('freeCapGiftSurpriseVariant');
      }, 280);
    }
  }

  function syncCart() {
    if (syncing || gifts.length === 0) {
      syncQueued = syncing;
      return Promise.resolve();
    }

    syncing = true;
    return request(config.cartUrl || '/cart.js')
      .then(function (cart) {
        var hasEligibleProduct = cart.items.some(isEligibleProduct);
        var giftItems = cart.items.filter(isGift);
        var storedGift = getStoredGift();

        if (!storedGift && giftItems.length) {
          storedGift = giftForItem(giftItems[0]);
          if (storedGift) storeGift(storedGift);
        }

        if (!hasEligibleProduct && giftItems.length) {
          return runSequentially(giftItems.map(function (item) {
            return function () { return changeGift(item.key, 0); };
          })).then(function () { finishCartChange(false); });
        }

        if (!hasEligibleProduct) {
          decorateGiftItems(false);
          return;
        }

        if (!storedGift) {
          openPicker(null, 'Choose your free gift to complete your cart');
          return;
        }

        var selectedLine = giftItems.find(function (item) {
          return Number(item.id) === Number(storedGift.variantId);
        });
        var tasks = [];

        giftItems.forEach(function (item) {
          if (!selectedLine || item.key !== selectedLine.key) {
            tasks.push(function () { return changeGift(item.key, 0); });
          }
        });
        if (selectedLine && selectedLine.quantity !== 1) {
          tasks.push(function () { return changeGift(selectedLine.key, 1); });
        }

        return runSequentially(tasks).then(function () {
          if (!selectedLine) {
            return addGift(storedGift).then(function () { finishCartChange(true, storedGift); });
          }
          if (tasks.length) finishCartChange(false, storedGift);
          decorateGiftItems(false);
        });
      })
      .catch(function (error) {
        console.warn('[Free Gift Picker]', error.message);
      })
      .finally(function () {
        syncing = false;
        if (syncQueued) {
          syncQueued = false;
          window.setTimeout(syncCart, 100);
        }
      });
  }

  function setPickerError(message) {
    if (!pickerError) return;
    pickerError.textContent = message || '';
    pickerError.hidden = !message;
  }

  function updatePickerSelection(gift) {
    selectedGift = gift;
    picker.querySelectorAll('.free-gift-option').forEach(function (option) {
      var isSelected = Number(option.getAttribute('data-gift-variant-id')) === Number(gift.variantId);
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
    confirmButton.disabled = false;
    confirmButton.textContent = pendingAction && pendingAction.type === 'buy-now'
      ? 'Continue to Buy Now'
      : pendingAction ? 'Add product + free gift' : 'Add selected gift to cart';
    setPickerError('');
  }

  function openPicker(action, heading) {
    if (!picker || !gifts.length) return;
    pendingAction = action;
    selectedGift = null;
    lastFocusedElement = document.activeElement;
    picker.hidden = false;
    picker.setAttribute('aria-hidden', 'false');
    document.body.classList.add('free-gift-picker-open');
    picker.querySelector('#FreeGiftPickerTitle').textContent = heading || 'Choose your free cap';
    picker.querySelectorAll('.free-gift-option').forEach(function (option) {
      option.classList.remove('is-selected');
      option.setAttribute('aria-checked', 'false');
    });
    confirmButton.disabled = true;
    confirmButton.textContent = 'Select a cap to continue';
    setPickerError('');
    window.setTimeout(function () {
      var firstOption = picker.querySelector('.free-gift-option:not([disabled])');
      if (firstOption) firstOption.focus();
    }, 20);
  }

  function closePicker() {
    if (!picker) return;
    picker.hidden = true;
    picker.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('free-gift-picker-open');
    pendingAction = null;
    selectedGift = null;
    if (lastFocusedElement && lastFocusedElement.focus) lastFocusedElement.focus();
  }

  function productLineForBuyNow(trigger) {
    var form = trigger.closest('form[action*="/cart/add"]');
    if (!form) {
      var productArea = trigger.closest('[data-section-type="product"], .product-template');
      form = productArea && productArea.querySelector('form[action*="/cart/add"]');
    }
    if (!form) form = document.querySelector('form[id^="AddToCartForm-"]');
    if (!form) return null;

    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var variantId = variantInput && Number(variantInput.value);
    if (!variantId) return null;

    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      if (input.disabled || !input.value) return;
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = input.value;
    });
    properties._free_cap_eligible = 'true';

    return {
      id: variantId,
      quantity: Math.max(1, Number(quantityInput && quantityInput.value) || 1),
      properties: properties
    };
  }

  function resumePendingAction(action, gift) {
    if (!action) {
      syncCart();
      return;
    }

    if (action.type === 'buy-now') {
      if (typeof window.onBuyNowClick !== 'function') {
        openPicker(action);
        setPickerError('Buy Now is still loading. Please try again.');
        return;
      }
      var productLine = productLineForBuyNow(action.trigger);
      if (!productLine) {
        openPicker(action);
        updatePickerSelection(gift);
        setPickerError('Please select a product option before continuing.');
        return;
      }
      window.onBuyNowClick(action.trigger, false, [productLine, {
        id: Number(gift.variantId),
        quantity: 1,
        properties: {
          _free_gift: 'Free Cap with Eligible Product',
          _gift_choice: gift.title
        }
      }]);
      return;
    }

    replayingAction = true;
    if (action.type === 'submit') {
      if (action.form.requestSubmit) action.form.requestSubmit(action.submitter || undefined);
      else action.form.submit();
    } else if (action.trigger) {
      action.trigger.click();
    }
    window.setTimeout(function () { replayingAction = false; }, 0);
  }

  function confirmSelection() {
    if (!selectedGift) return;
    var gift = selectedGift;
    var action = pendingAction;
    storeGift(gift);
    closePicker();
    resumePendingAction(action, gift);
  }

  function actionForTrigger(trigger) {
    if (trigger.id === 'gokwik-buy-now') return { type: 'buy-now', trigger: trigger };
    return { type: 'click', trigger: trigger };
  }

  function interceptClick(event) {
    if (replayingAction || event.button > 0) return;
    var trigger = event.target.closest('#gokwik-buy-now, button[name="add"], .js-grid-cart, .qv-add-button');
    if (!trigger || trigger.disabled || trigger.classList.contains('disabled')) return;
    if (!elementIsEligible(trigger)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    rememberElementEligibility(trigger);
    markFormEligible(trigger.closest('form[action*="/cart/add"]'));
    openPicker(actionForTrigger(trigger));
  }

  function interceptSubmit(event) {
    if (replayingAction) return;
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]') || !elementIsEligible(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    rememberElementEligibility(form);
    markFormEligible(form);
    openPicker({ type: 'submit', form: form, submitter: event.submitter || form.querySelector('button[name="add"]') });
  }

  function captureQuickViewEligibility(event) {
    var trigger = event.target.closest('.js-btn-quickview');
    if (!trigger) return;
    var source = trigger.closest('.js-product-card');
    var quickView = document.getElementById('jsQuickview');
    if (!source || !quickView) return;
    quickView.setAttribute('data-free-cap-eligible', source.getAttribute('data-free-cap-eligible') || 'false');
    quickView.setAttribute('data-product-id', source.getAttribute('data-product-id') || '');
  }

  function scheduleSync() {
    window.clearTimeout(scheduleSync.timer);
    scheduleSync.timer = window.setTimeout(syncCart, 140);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return originalFetch.apply(window, args).then(function (response) {
      var target = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (cartMutationPattern.test(target)) scheduleSync();
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__freeGiftCartMutation = cartMutationPattern.test(String(url || ''));
    if (this.__freeGiftCartMutation) this.addEventListener('loadend', scheduleSync, { once: true });
    return originalOpen.apply(this, arguments);
  };

  function init() {
    picker = document.getElementById('FreeGiftPicker');
    confirmButton = document.getElementById('FreeGiftPickerConfirm');
    pickerError = document.getElementById('FreeGiftPickerError');

    if (!picker || gifts.length === 0) {
      console.warn('[Free Gift Picker] Both gift products must be active on the Online Store sales channel.');
      return;
    }

    picker.querySelectorAll('.free-gift-option').forEach(function (option) {
      option.addEventListener('click', function () {
        var gift = giftByVariantId(option.getAttribute('data-gift-variant-id'));
        if (gift) updatePickerSelection(gift);
      });
    });
    picker.querySelectorAll('[data-free-gift-close]').forEach(function (button) {
      button.addEventListener('click', closePicker);
    });
    confirmButton.addEventListener('click', confirmSelection);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !picker.hidden) closePicker();
    });
    document.addEventListener('click', interceptClick, true);
    document.addEventListener('click', captureQuickViewEligibility, true);
    document.addEventListener('submit', interceptSubmit, true);

    new MutationObserver(function () { decorateGiftItems(false); })
      .observe(document.body, { childList: true, subtree: true });

    decorateGiftItems(sessionStorage.getItem('freeCapGiftSurprise') === '1');
    if (sessionStorage.getItem('freeCapGiftSurprise') === '1') {
      showSurprise(giftByVariantId(sessionStorage.getItem('freeCapGiftSurpriseVariant')) || getStoredGift());
      sessionStorage.removeItem('freeCapGiftSurprise');
      sessionStorage.removeItem('freeCapGiftSurpriseVariant');
    }
    syncCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
